import React, {useRef, useState} from "react";
import {Button, Form, Input, message, Modal, Upload} from "antd";
import {FileAddOutlined} from "@ant-design/icons";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";

export const ExpenseVoucherModal = ({visible, record, onClose, onSuccess}) => {
    const stores = useStore();
    const [form] = Form.useForm();
    const [file, setFile] = useState(null);
    const formDataRef = useRef(null);

    const [loading, , , , refetch] = useFetch({
        fetchFn: () => stores.courierWithdrawRequestStore.addExpenseVoucher(formDataRef.current),
        initialCall: false,
        callbackFunc: result => {
            if (result?.success) {
                message.success("Gider pusulası başarıyla yüklendi.");
                form.resetFields();
                setFile(null);
                onSuccess?.();
                onClose();
            } else {
                form.setFields([
                    {
                        name: "expenseVoucherNumber",
                        errors: [result?.message || "Gider pusulası yüklenemedi."]
                    }
                ]);
            }
        }
    });

    const handleConfirm = async () => {
        if (!file) {
            message.error("Lütfen bir dosya seçiniz.");
            return;
        }
        try {
            const values = await form.validateFields();
            const formData = new FormData();
            formData.append("id", record?._id);
            formData.append("expenseVoucherNumber", values.expenseVoucherNumber);
            formData.append("file", file);
            formDataRef.current = formData;
            refetch();
        } catch (error) {
            // form validation hatası, refetch tetiklenmez
        }
    };

    const handleCancel = () => {
        form.resetFields();
        setFile(null);
        onClose();
    };

    return (
        <Modal
            visible={visible}
            title="Gider Pusulası Yükle"
            okText="Yükle"
            cancelText="Vazgeç"
            centered
            destroyOnClose
            confirmLoading={loading}
            onOk={handleConfirm}
            onCancel={handleCancel}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="expenseVoucherNumber"
                    label="Gider Pusula Numarası"
                    rules={[{required: true, message: "Gider pusula numarası zorunludur"}]}
                >
                    <Input placeholder="Gider pusula numarası giriniz" />
                </Form.Item>
                <Form.Item label="Dosya" required>
                    <Upload
                        maxCount={1}
                        fileList={file ? [file] : []}
                        beforeUpload={selectedFile => {
                            setFile(selectedFile);
                            return false;
                        }}
                        onRemove={() => setFile(null)}
                    >
                        <Button icon={<FileAddOutlined />}>Dosya Seç</Button>
                    </Upload>
                </Form.Item>
            </Form>
        </Modal>
    );
};
